import {
  Avatar,
  ui,
  useRuntimeEnv,
  useTranslationRoute,
  useTranslations,
  useUserProfilePicture,
} from "@harea/component";
import {
  BellIcon,
  BuildingIcon,
  LogOutIcon,
  ReceiptIcon,
  UserIcon,
} from "lucide-react";
import { Link } from "react-router-dom";

export function UserProfileDropdown() {
  const profilePictureUrl = useUserProfilePicture();
  const { runtimeEnv } = useRuntimeEnv();
  const tr = useTranslationRoute();
  const [MY_ACCOUNT, MY_ORGANISATION, NOTIFICATIONS, BILLING, LOGOUT] =
    useTranslations(i18n);

  return (
    <ui.DropdownMenu>
      <ui.DropdownMenuTrigger
        aria-label={MY_ACCOUNT}
        className="flex items-center gap-2 rounded-lg px-2 py-1.5 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Avatar
          src={profilePictureUrl(runtimeEnv?.user?.id!)}
          size="sm"
          fullName={runtimeEnv?.user?.fullName}
        />
      </ui.DropdownMenuTrigger>
      <ui.DropdownMenuContent
        align="end"
        sideOffset={4}
        className="w-60 min-w-48 origin-top-right rounded-xl border border-sidebar-border bg-sidebar text-sidebar-foreground shadow-xl shadow-black/20"
      >
        <div className="flex min-w-0 flex-col gap-1 border-b border-sidebar-border px-4 py-3">
          <span className="truncate text-sm font-semibold text-sidebar-foreground">
            {runtimeEnv?.user?.fullName}
          </span>
          <span className="truncate text-xs text-sidebar-foreground/70">
            {runtimeEnv?.user?.email}
          </span>
        </div>
        <div className="p-1">
          <ui.DropdownMenuItem
            asChild
            className="gap-3 text-sidebar-foreground hover:border-0 hover:outline-none hover:ring-0 focus:bg-sidebar-accent focus:text-sidebar-accent-foreground"
          >
            <Link to={tr("admin/my-account")}>
              <UserIcon className="size-4" aria-hidden="true" />
              {MY_ACCOUNT}
            </Link>
          </ui.DropdownMenuItem>
          <ui.DropdownMenuItem
            asChild
            className="gap-3 text-sidebar-foreground hover:border-0 hover:outline-none hover:ring-0 focus:bg-sidebar-accent focus:text-sidebar-accent-foreground"
          >
            <Link to={tr("admin/my-organization")}>
              <BuildingIcon className="size-4" aria-hidden="true" />
              {MY_ORGANISATION}
            </Link>
          </ui.DropdownMenuItem>
          <ui.DropdownMenuItem
            asChild
            className="gap-3 text-sidebar-foreground hover:border-0 hover:outline-none hover:ring-0 focus:bg-sidebar-accent focus:text-sidebar-accent-foreground"
          >
            <Link to={tr("admin/notifications")}>
              <BellIcon className="size-4" aria-hidden="true" />
              {NOTIFICATIONS}
            </Link>
          </ui.DropdownMenuItem>
          <ui.DropdownMenuItem
            asChild
            className="gap-3 text-sidebar-foreground hover:border-0 hover:outline-none hover:ring-0 focus:bg-sidebar-accent focus:text-sidebar-accent-foreground"
          >
            <Link to={tr("admin/billing/subscription")}>
              <ReceiptIcon className="size-4" aria-hidden="true" />
              {BILLING}
            </Link>
          </ui.DropdownMenuItem>
        </div>
        <ui.DropdownMenuSeparator className="my-1 h-px bg-sidebar-border" />
        <div className="p-1">
          <ui.DropdownMenuItem
            asChild
            className="gap-3 text-destructive hover:border-0 hover:outline-none hover:ring-0 focus:bg-destructive/10 focus:text-destructive"
          >
            <Link to={tr("logout")}>
              <LogOutIcon className="size-4" aria-hidden="true" />
              {LOGOUT}
            </Link>
          </ui.DropdownMenuItem>
        </div>
      </ui.DropdownMenuContent>
    </ui.DropdownMenu>
  );
}

const i18n = [
  "std_my_account",
  "std_my_organization",
  "Harea.Admin.LeftSideBar.Menu.General.Notifications.Label",
  "std_billing",
  "std_logout",
];